import { createAsyncReducer } from '../../standard-actions/';
import {
    ILoadRequestCategoryWithItemQuestionsAction,
    ILoadRequestCategoryWithItemQuestionsSuccessAction,
    ILoadRequestCategoryWithItemQuestionsErrorAction
} from '../actions/load-request-category-with-item-questions';
import { IServiceRequestsState } from '../state';
import { initialState } from '@telstra-connect/service-requests/state/initial-state';

export type RequestCategoryWithItemQuestionsAction
    = ILoadRequestCategoryWithItemQuestionsAction
    | ILoadRequestCategoryWithItemQuestionsSuccessAction
    | ILoadRequestCategoryWithItemQuestionsErrorAction;

const init = (state: IServiceRequestsState, action: RequestCategoryWithItemQuestionsAction) => {
    return ({
        ...state,
        requestCategoryWithItemQuestions: {
            ...initialState.requestCategoryWithItemQuestions,
            status: action.status,
        }
    });
}

const success = (state: IServiceRequestsState, action: RequestCategoryWithItemQuestionsAction) => {
    return ({
        ...state,
        requestCategoryWithItemQuestions: {
            ...initialState.requestCategoryWithItemQuestions,
            status: action.status,
            items: (action as ILoadRequestCategoryWithItemQuestionsAction).items,
            metaData: (action as ILoadRequestCategoryWithItemQuestionsAction).metaData

        }
    });
}

const failure = (state: IServiceRequestsState, action: RequestCategoryWithItemQuestionsAction) => ({
    ...state,
    requestCategoryWithItemQuestions: {
        ...initialState.requestCategoryWithItemQuestions,
        status: action.status,
        error: (action as ILoadRequestCategoryWithItemQuestionsErrorAction).error
    }
});

export const serviceRequestCategoryWithItemQuestionsReducer = createAsyncReducer(initialState, init, success, failure);
